import React, { type FC, type ReactNode } from 'react'
import type { BoxStatus } from '../api/boxApi'
import { UserVotesScrollBoxes } from './UserVotesScrollBoxes'
import { CreatedBoxesScrollBoxes } from './CreatedBoxesScrollBoxes'
import { AllBoxesScrollBoxes } from './AllBoxesScrollBoxes'

export const Boxes: FC<{
  titleElement: ReactNode | null
  tabsElement: ReactNode
  status: BoxStatus
  votedByMe?: boolean
  createdByMe?: boolean
  lang?: string
  filterType?: 'all' | 'my' | 'my-votes' | 'finished'
}> = ({
  titleElement,
  tabsElement,
  status,
  votedByMe,
  createdByMe,
  lang,
  filterType,
}) => {
  if (votedByMe) {
    return (
      <UserVotesScrollBoxes
        titleElement={titleElement}
        tabsElement={tabsElement}
      />
    )
  }

  if (createdByMe) {
    return (
      <CreatedBoxesScrollBoxes
        titleElement={titleElement}
        tabsElement={tabsElement}
      />
    )
  }

  return (
    <AllBoxesScrollBoxes
      titleElement={titleElement}
      tabsElement={tabsElement}
      status={status}
      lang={lang}
      filterType={filterType}
    />
  )
}
